(function() {
    'use strict';

    angular.module( APP_ID )
        .run([ '$rootScope', '$window', '$trace', '$analytics', '$transitions', '$uiRouter', 'MetaService', 'ContentSwitchingService', 'AutoscrollService', 'LoggerFactory', 'TrackerService', 'App', 'TEXTS', 'CONFIG', AppStarter ]);

    /**
     * Executes on startup.
     *
     * @param {ng.IRootScopeService} $rootScope
     * @param {ng.IWindowService} $window
     * @param {ng.ITraceService} $trace
     * @param {uirouter.Transitions} $transitions
     * @param {uirouter.UrlRouter} $uiRouter
     * @param {MetaService} MetaService
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {AutoscrollService} AutoscrollService
     * @param {LoggerFactory} LoggerFactory
     * @param {TrackerService} TrackerService
     * @param {App} App
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function AppStarter(
        $rootScope,
        $window,
        $trace,
        $analytics,
        $transitions,
        $uiRouter,

        MetaService,
        ContentSwitchingService,
        AutoscrollService,
        LoggerFactory,
        TrackerService,

        App,
        TEXTS,
        CONFIG
    ){

        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'Startup' );





        /* ===== PRIVATE ATTRIBUTES ========================================= */


        /** @type {function} */
        var deregisterModeSetterHook    = null;





        /* ===== APP'S STARTUP ============================================== */


        /** @constructor */
        (function init(){
            bindImmutables();
            registerTransitionHooks();

            if ( CONFIG.IS_DEVELOPMENT_MODE ) {
                // Transition debugging
                $trace.enable( 'TRANSITION' );

                // State debugging visualiser
                var vis = $window[ 'ui-router-visualizer' ];
                if ( vis ) vis.visualizer( $uiRouter );
            }

            normaliseAngularticsBase();

            TrackerService.logKISReturn();
            AutoscrollService.activate();
        })();





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function normaliseAngularticsBase() {
            if ( CONFIG.BASEPATH[ CONFIG.BASEPATH.length - 1 ] == '/' ) {
                $analytics.settings.pageTracking.basePath = CONFIG.BASEPATH.slice( 0, -1 );
            }
        }


        function bindImmutables() {
            // Propagate important components into templates
            $rootScope.CONFIG      = CONFIG;
            $rootScope._           = TEXTS;

            // Warning: Partially immutable properties - be careful to read-only
            $rootScope.MetaService = MetaService;
        }


        function registerTransitionHooks() {
            deregisterModeSetterHook = $transitions.onBefore( { to: '**' }, forceModeFromParameter );

            ContentSwitchingService.registerTransitionHooks();

            // Start tracking ALL successful {Transition}s
            $transitions.onSuccess( { to: '**' }, function( $transition$ ){
                if ( !$uiRouter.globals.hasOwnProperty( 'allSuccessTransitions' ) ) {
                    $uiRouter.globals.allSuccessTransitions = [];
                }

                $uiRouter.globals.allSuccessTransitions.push( $transition$ );
            });
        }


        /** When the app loads, check if parameter 'mode' is present and forcefully switches the state. Runs *ONLY* once. */
        function forceModeFromParameter( $transition$ ) {
            // Mode enforced or not - deregister
            deregisterModeSetterHook();

            var params = $transition$.params();

            if ( params.hasOwnProperty( CONFIG.PARAMS.MODE ) && params[ CONFIG.PARAMS.MODE ] ){
                logger.debug( "Force switching into mode '%s'...", params[ CONFIG.PARAMS.MODE ]);
                App.setContentMode( params[ CONFIG.PARAMS.MODE ] );
            }

        }
    };
})();

